var _ref2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRefresh = function SvgRefresh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M12 0L8 4L12 8V5C15.859 5 19 8.14 19 12C19 12.88 18.8293 13.7201 18.5312 14.4961L20.0469 16.0098C20.6519 14.8008 21 13.442 21 12C21 7.038 16.963 3 12 3V0ZM3.95312 7.99023C3.34812 9.19923 3 10.558 3 12C3 16.962 7.037 21 12 21V24L16 20L12 16V19C8.141 19 5 15.86 5 12C5 11.12 5.17075 10.2799 5.46875 9.50391L3.95312 7.99023Z",
      fill: "#041F47"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgRefresh, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/refresh.1a44b13f.svg";
export { ForwardRef as ReactComponent };